import React from "react";

const PhotoForFileInput = (props: any) => {
    return (
        <div
            style={{
                backgroundImage: `url(${props.url})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                width: "auto",
                height: "65%",
            }}
        />
    );
};

export default PhotoForFileInput;
